<template src="./template.html"></template>
<script>
import { mapState } from 'vuex'
import _sortBy from 'lodash/sortBy'

import membershipPlanService from 'api/membershipPlan'
import Login from 'components/Login'
import * as mutationTypes from 'store/mutationTypes'
import store from 'store'
import membershipLib from 'lib/membership'
import eventBus from 'lib/eventBus'

export default {
  name: 'membership-signup',
  components: {
    Login,
  },
  computed: {
    ...mapState({
      loggedIn: (state) => state.auth.loggedIn,
      user: (state) => state.user.current,
      currentPlan: (state) => state.membership.currentPlan,
    }),
    isUserMember() {
      return membershipLib.isUserMember(this.user)
    },
  },
  data() {
    return {
      loading: false,
      membershipPlans: null,
    }
  },
  methods: {
    selectPlan(plan) {
      plan.discounts = []
      plan.promoCode = null

      this.$store.dispatch('setCurrentMembershipPlan', plan)

      if (this.user) {
        if (this.isUserMember) {
          this.$router.push({
            name: 'MembershipPerks',
          })
        } else {
          this.$router.push({
            name: 'MembershipCheckout',
          })
        }
      }
    },
    getMembershipPlans() {
      this.loading = true

      return membershipPlanService
        .list()
        .then((results) => {
          this.loading = false

          this.membershipPlans = _sortBy(results, 'billingPrice')
        })
        .catch(() => {
          this.loading = false
        })
    },
    onMutation(mutation) {
      if (mutation.type === mutationTypes.LOGIN_SUCCESS) {
        this.loading = true

        this.$store.dispatch('getCurrentUser').then(() => {
          if (this.isUserMember) {
            this.$router.push({
              name: 'MembershipPerks',
            })
          } else {
            this.$router.push({
              name: 'MembershipCheckout',
            })
          }
        })
      }
    },
  },
  mounted() {
    this.storeUnsubscribe = store.subscribe(this.onMutation)

    this.getMembershipPlans()
  },
  updated() {
    eventBus.$emit('updated')
  },
  destroyed() {
    this.storeUnsubscribe()
  },
}
</script>



// WEBPACK FOOTER //
// src/components/MembershipSelectPlan/index.vue